module.exports = __webpack_public_path__ + "img/product_10.02edcea.webp";